import React, {Component} from 'react';
import dummyImage from '../../../images/small/img-1.jpg';
import classNames from 'classnames';

class ContactPerson extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let image = dummyImage;

        if(this.props.image) {
            image = this.props.image;
        }

        return (
            <div className={classNames(...this.props.classes || ["col-md-6", "col-lg-6", "col-xl-3"])}>
                <div className="card m-b-20">
                    <div className="card-block">
                        <h4 className="card-title font-20 mt-0">{this.props.name}</h4>
                    </div>
                    <img className="img-fluid" src={image} alt="Card image cap"/>
                    <div className="card-block">
                    <b className="text-muted">Tlf.: </b> <a href={`tel:${this.props.phone}`} className="common-decor">{this.props.phone}</a>
                        <p><a href={`mailto:${this.props.email}`} className="common-decor">{this.props.email}</a></p>
                    </div>
                </div>

            </div>
        );
    }
}

export default ContactPerson;


// WEBPACK FOOTER //
// ./web/src/components/dashboard/ContactPerson.jsx